<template>
    <v-row class="full-size">
        <v-row id="left-panel">
           
            <v-stepper v-model="step" vertical>
                <h4 class="ministry">{{kanbanInfo.ministryId}}</h4>
                <v-stepper-step :complete="step > 1" step="1" @click="previous" > 発電所範囲確定 </v-stepper-step>
                <v-stepper-content step="1">
                    <v-card color="grey lighten-1" class="mb-12" height="100px" style="padding: 10px;">
                        <small>発電所の範囲のポリゴンを選択してください。</small>
                        <v-row>
                            <v-col cols="6">
                                <v-btn class="btn" color="primary" :disabled="status!=='NEW'" @click="selectPolygon">範囲確定</v-btn>
                            </v-col>
                            <v-col cols="6">
                                <v-btn class="btn" color="default" :disabled="status==='NEW'" @click="deleteSelectedPolygon">範囲解除</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-stepper-content>
                <v-stepper-step :complete="step > 2" step="2" @click="next" > フライト範囲編集 </v-stepper-step>
                <v-stepper-content step="2">
                    <v-card color="grey lighten-1" class="mb-12" height="400px" style="padding: 10px;">
                        <small>ポリゴンを編集してフライト範囲を確定してください。</small>
                        <v-row>
                            <v-col cols="6">
                                <v-btn
                                class="btn"
                                block
                                :color="polygonMap.mode === 'add' ? 'primary' : 'default'"
                                @click="addRectangleAnotation(polygonMap.mode === 'add' ? 'none' : 'add')"
                                >
                                    <v-icon left>mdi-map-marker-plus</v-icon>ポリゴン追加
                                </v-btn>
                            </v-col>
                            <v-col cols="6">
                                <v-btn class="btn" block color="default" :disabled="polygonSelected.length === 0" @click="deleteRectangleAnotation">
                                    <v-icon dark left>mdi-minus-circle</v-icon>ポリゴン削除
                                </v-btn>
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-btn class="btn" color="default" @click="download" :disabled="status !== 'FLIGHT_AREA_CONFIRMED'">ダウンロード</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn class="btn" color="primary" :disabled="polygonMap.source.getFeatures().length === 0" @click="storePolygon">確定</v-btn>
                                <div class="text" v-if="status === 'FLIGHT_AREA_CONFIRMED'">
                                    <p>確定者：{{ formatText(userInfo.updated_user) }}</p>
                                    <p>確定時点：{{userInfo.updated_at}}</p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn class="btn" color="success" @click="storeFlight" :disabled="status !== 'FLIGHT_AREA_CONFIRMED'">撮影完了</v-btn>
                                <div class="text" v-if="userInfo.flight_status == true">
                                    <p>撮影者：{{ formatText(userInfo.flight_completed_user)}}</p>
                                    <p>撮影完了時点：{{userInfo.flight_completed_at}}</p>
                                </div>
                                
                            </v-col>
                        </v-row>
                    </v-card>
                </v-stepper-content>

                <div id="layer">
                    <v-expansion-panels accordion tile multiple>
                    <v-expansion-panel
                        v-for="(item, i) in layers"
                        :key="i"
                    >
                        <v-expansion-panel-header class="px-3">
                        <v-checkbox
                            v-model="item.visible"
                            :label="item.text"
                            @click="onChangeVisible($event, item)"
                            hide-details="auto"
                        ></v-checkbox>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                        <div v-if="item.value === 'flightBanArea'" class="ml-5">
                            <v-checkbox
                                v-model="item.didZone.visible"
                                :label="item.didZone.text"
                                @click="onChangeVisible($event, item.didZone)"
                                hide-details="auto"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="item.noFlightZone.visible"
                                :label="item.noFlightZone.text"
                                @click="onChangeVisible($event, item.noFlightZone)"
                                hide-details="auto"
                            ></v-checkbox>
                        </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    </v-expansion-panels>
                    
                </div>
            </v-stepper>
          
        </v-row>
        <v-col id="map">
            <div id="mapPolygon" class="mapPolygon" ref="mapPolygon"></div>
        </v-col>
        <pfs-show-kanban-dialog
        v-model="showKanbanDialog"
        :info="kanbanInfo"
        ></pfs-show-kanban-dialog>
        <v-snackbar v-model="snackbar" top>
            {{ message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                color="pink"
                text
                v-bind="attrs"
                @click="snackbar = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>
<script>
// import { saveAs } from "file-saver";
import {store} from "@/store";
import 'ol/ol.css'
import Map from 'ol/Map'
import LayerGroup from 'ol/layer/Group';
import View from 'ol/View'
import GoogleLayer from 'olgm/layer/Google.js';
import {defaults} from 'olgm/interaction.js';
import OLGoogleMaps from 'olgm/OLGoogleMaps.js';
import * as olProj from 'ol/proj';
// import TileLayer from 'ol/layer/Tile';
// import XYZ from 'ol/source/XYZ';
// import Projection from 'ol/proj/Projection';

import PfsPolygon from "@/utils/pfsPolygon";
import PfsShowKanbanDialogVue from '../dialog/PfsShowKanbanDialog.vue';
import NoFlightZone from "@/utils/noFlightZone";
import DIDZone from "@/utils/didZone";

import {unByKey} from 'ol/Observable';

export default {
    name: 'PfsData',
    components: {
    'pfs-show-kanban-dialog': PfsShowKanbanDialogVue,
  },
    data() {
        return {   
            plantId: this.$route.params.kikanId,
            data: null,
            ministry_id : null,
            step: null,  
            status: null, 
            polygonMap: new PfsPolygon(),
            mapview: null,
            listPolygonData: [],
            polygonSelected: [],
            index:0,
            select: [],
            showKanbanDialog: false,
            kanbanInfo: {
                "ministryId": "",
                "address": "",
                "dc": "",
                "longitude": "",
                "latitude": "",
            },
            //snackbar
            snackbar: false,
            message: null,

            // 撮影情報
            userInfo: {
                "flight_completed_user": "",
                "flight_completed_at": "",
                "updated_user": "",
                "updated_at": "",
                "flight_status": false,
            },
            //
            key: null,

            layers: null,
            noFlightZone: new NoFlightZone(),
            didZone: new DIDZone(),
        };
    },
    methods: {
        init() {
            this.resetLayers();
            this.kanbanInfo = [];
            this.axios
            .get("/api/pfs/plant/" + this.plantId)
            .then((response) => {
                
                if(response.data.data != null) {
                    this.data = response.data.data;
                    this.status = response.data.data.status;
                }else{
                    this.status = "NEW";
                }
                
                this.kanbanInfo = response.data.kanbanInfo;

                this.polygonMap.setSourceSignBoard(this.kanbanInfo);
                if (this.status === "PLANT_AREA_CONFIRMED" || this.status === "FLIGHT_AREA_CONFIRMED") {
                    const polygons = response.data.raw_polygons.list;
                    polygons.forEach(element => {
                        this.listPolygonData.push(element);
                    });
                    this.setPfsPolygon(polygons);
                } else {
                    const polygons = response.data.raw_polygons;
                    this.setRawPolygon(polygons);
                }
                const googleLayer = new GoogleLayer({
                    mapTypeId: 'satellite',
                });
                this.mapview = new Map({
                    interactions: defaults(),
                    target: this.$refs.mapPolygon,
                    layers: [
                        googleLayer,
                       
                        // new LayerGroup({
                        //     title: 'Base maps',
                        //     layers: [
                        //         new TileLayer({
                        //             title: 'googlemap',
                        //             visible: true,
                        //             source: new XYZ({
                        //                 url: `https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}`,
                        //                 maxZoom: 17,

                        //             })
                        //         }),

                        //     ]
                        // }),
                        new LayerGroup({
                            id: 'polygon',
                            title: '発電所のポリゴン',
                            zIndex: 4,
                            layers: [
                                this.polygonMap.layer,
                                this.polygonMap.layerSignBoard,
                            ]
                        }),
                        new LayerGroup({
                            id: 'flightBanArea',
                            zIndex: 1,
                            layers: [
                                this.noFlightZone.layerNoFlightZone,
                                this.didZone.layerDIDZone,
                            ]
                        }),
                    ],
                    view: new View({
                        center: olProj.transform([this.kanbanInfo["longitude"],this.kanbanInfo["latitude"]], 'EPSG:4326', 'EPSG:3857'),
                        zoom: 17,
                        maxZoom: 19,
                    })
                });
                this.didZone.init(this.mapview);

                this.step = response.data.step;
                if(this.data !=null && this.data.flight_status != null) {
                    this.userInfo["flight_completed_user"] = this.data.flight_completed_user;
                    this.userInfo["flight_completed_at"] = this.data.flight_completed_at;
                    this.userInfo["flight_status"] = this.data.flight_status;
                }

                if (this.status === "FLIGHT_AREA_CONFIRMED") {
                    this.userInfo["updated_user"] = this.data.updated_user;
                    this.userInfo["updated_at"] = this.data.updated_at;
                }

                const olGM = new OLGoogleMaps({map: this.mapview}); // map is the ol.Map instance
                olGM.activate();
                olGM.getGoogleMapsMap().setTilt(0);            

                this.mapview.on("pointermove", (evt) =>{
                    const pixel = this.mapview.getEventPixel(evt.originalEvent);
                    const hit = this.mapview.hasFeatureAtPixel(pixel);
                    this.mapview.getTarget().style.cursor = hit ? 'pointer' : '';
                });
                this.mapview.on('click', (evt) => {
                    if (this.step === 1) {
                        const pixel = this.mapview.getEventPixel(evt.originalEvent);
                        const hit = this.mapview.hasFeatureAtPixel(pixel);
                        if(hit) {
                            this.mapview.forEachFeatureAtPixel(evt.pixel, (feature) => {
                                this.select.push(feature);
                            });
                            const feature = this.select[0];
                            if (this.status === "NEW") {
                                if(feature.get("type") === "point") {
                                    this.displaySignBoard();
                                    this.select = [];
                                }
                                if (feature.get("type") === "Feature") {
                                    if (this.polygonSelected.includes(feature)) {
                                        this.index -=1;
                                        feature.setStyle(this.polygonMap.featureStyleRaw);
                                        const index_array = this.polygonSelected.indexOf(feature);
                                        if (index_array > -1) {
                                            this.polygonSelected.splice(index_array, 1);
                                        }
                                        this.polygonSelected.forEach(element => {
                                            if (element.get("index") > feature.get("index")) {
                                                const new_index = element.get("index") -1;
                                                element.set("index", new_index);
                                            }
                                        });

                                    }else{
                                        this.index +=1;
                                        feature.setStyle(
                                        this.polygonMap.modifyStyleFunction,
                                        );
                                        feature.set("index", this.index);
                                        this.polygonSelected.push(feature);
                                    }
                                    this.select = [];
                                }

                            } else if (this.status === "PLANT_AREA_CONFIRMED" || this.status === "FLIGHT_AREA_CONFIRMED") {
                                if(feature.get("type") === "Feature") {
                                    this.select = [];
                                    return;
                                }
                                if(feature.get("type") === "point") {
                                    const info = [];
                                    this.displaySignBoard(info);
                                    this.select = [];
                                }
                            }
                        }else {
                            this.polygonSelected.forEach(element => {
                                element.setStyle(this.polygonMap.featureStyleRaw);
                            });
                            this.polygonSelected = [];
                            this.index = 0;
                        }
                    }else if(this.step === 2) {
                        if (this.polygonMap.mode !== "add") {
                            const pixel = this.mapview.getEventPixel(evt.originalEvent);
                            const hit = this.mapview.hasFeatureAtPixel(pixel);
                            if(hit) {
                                this.mapview.forEachFeatureAtPixel(evt.pixel, (feature) => {
                                    this.select.push(feature);
                                });
                                const feature = this.select[0];
                                if(feature.get("type") === "point"){
                                    const info = [];
                                    this.displaySignBoard(info);
                                    this.select = [];
                                }else if (feature.get("type") === "Feature") {
                                    if (this.polygonSelected.includes(feature)) {
                                        
                                        feature.setStyle(this.polygonMap.featureStyleFunction);
                                        const index_array = this.polygonSelected.indexOf(feature);
                                        if (index_array > -1) {
                                            this.polygonSelected.splice(index_array, 1);
                                            if(this.polygonSelected.length == 1) {
                                                this.polygonMap.setModify(this.mapview, this.polygonSelected[0], () => this.editRectangleAnotation());
                                            }else{
                                                this.mapview.removeInteraction(this.polygonMap.modify);
                                            }
                                        }
                                    }else{
                                        feature.setStyle(this.polygonMap.modifyStyleFunction);
                                        this.polygonSelected.push(feature);
                                        if(this.polygonSelected.length == 1) {
                                            this.polygonMap.setModify(this.mapview, feature, () => this.editRectangleAnotation());
                                            
                                        }else{
                                            this.mapview.removeInteraction(this.polygonMap.modify);
                                        }
                                    }
                                    this.select = [];
                                }
                            } else {
                                this.polygonSelected.forEach(element => {
                                    element.setStyle(this.polygonMap.featureStyleFunction);
                                });
                                this.polygonSelected = [];
                                this.mapview.removeInteraction(this.polygonMap.modify);
                            }
                        }
                    }
                });
            });
        },
        // 範囲に編集
        addRectangleAnotation(mode) {
            this.polygonMap.mode = mode;
            if (this.polygonMap.mode !== "add") {
                this.mapview.removeInteraction(this.polygonMap.draw);
                if(this.key != null){
                    unByKey(this.key);
                }
            } else {
                this.mapview.addInteraction(this.polygonMap.draw);
                this.key = this.polygonMap.draw.on('drawend', (evt) => {
                    const feature = evt.feature;
                    const features = this.polygonMap.source.getFeatures();
                    const lengthIndex = features.length + 1;
                    feature.set("index", lengthIndex);
                    feature.set("type", "Feature");
                    feature.setId(lengthIndex);
                    feature.setStyle(this.polygonMap.featureStyleFunction);
                });
            } 
        },

        setPfsPolygon(array_polygons) {
            this.polygonMap.drawPolygonOnMap(array_polygons, this.polygonMap.featureStyleFunction);
        },

        deleteRectangleAnotation() {
            this.polygonMap.removeFeature(this.polygonSelected);
            this.polygonSelected = [];
            this.mapview.removeInteraction(this.polygonMap.modify);

        },

        editRectangleAnotation() {
            this.mapview.removeInteraction(this.polygonMap.modify);
            this.polygonSelected = [];
        },

        storePolygon() {
            const listPolygonData = [];
            const features = this.polygonMap.source.getFeatures();
            features.forEach(element => {
                const data = {
                    "Id": null,
                    "index": null,
                    "points": [],
                }
                const coordinates = element.getGeometry().getCoordinates(true)[0];
                data["Id"] = element.getId();
                data["index"] = element.get("index");
                
                for (let index = 0; index < coordinates.length; index++) {
                    const startPoint = coordinates[0];
                    if(index!= 0 && startPoint === coordinates[index]) {
                        break;
                    }
                    const point = olProj.transform([coordinates[index][0], coordinates[index][1]], 'EPSG:3857', 'EPSG:4326');
                    const info = {
                        "POINT_X": point[0],
                        "POINT_Y": point[1],
                    }
                    data["points"].push(info);
                    // index = index +2;
                }
                listPolygonData.push(data);  
            });
            this.axios
            .post("/api/pfs/polygon/", {'info': listPolygonData, 'kikandb_id': this.plantId})
            .then((response) => {
                if(response.data.status == true){
                    this.mapview.removeInteraction(this.polygonMap.draw);
                    this.polygonMap.mode = null;
                    this.setPfsPolygon(response.data.polygon.final_polygons.list);

                    this.snackbar = true;
                    this.message = "フライト範囲を確定しました。";

                    this.userInfo["updated_user"] = response.data.polygon.updated_user;
                    this.userInfo["updated_at"] = response.data.polygon.updated_at;

                    this.status = response.data.polygon.status;
                }
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
        },
        setRawPolygon(array_polygons) {
            this.polygonMap.drawRawPolygon(array_polygons);
        },

        selectPolygon() {
            const listPolygonData = [];
            this.polygonSelected.forEach(element => {
                const data = {
                    "Id": null,
                    "index": null,
                    "points": [],
                }
                const coordinates = element.getGeometry().getFlatCoordinates();
                data["Id"] = element.get("index");
                data["index"] = element.get("index");
                for (let index = 0; index < coordinates.length;) {
                    const point = olProj.transform([coordinates[index], coordinates[index+1]], 'EPSG:3857', 'EPSG:4326');
                    const info = {
                        "POINT_X": point[0],
                        "POINT_Y": point[1],
                    }
                    data["points"].push(info);
                    index = index +2;
                }
                listPolygonData.push(data);   
            });
            this.axios
            .post("/api/pfs/rawpolygon/", {'info': listPolygonData, 'kikandb_id': this.plantId, 'ministry_id': this.kanbanInfo.ministryId})
            .then((response) => {
                const polygons = response.data.polygon.final_polygons.list;
                this.setPfsPolygon(polygons);
                this.step = 2;
                this.status = response.data.status;
                this.snackbar = true;
                this.message = "発電所の範囲のポリゴンを確定しました。";
                this.polygonSelected = [];
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
        },

        previous() {
            this.axios
            .post("/api/pfs/coordinates/", {'kikandb_id': this.plantId})
            .then((response) => {
                const polygons = response.data.selected_polygons.list;
                this.polygonMap.drawPolygonOnMap(polygons, this.polygonMap.featureStyleSelected);
                this.step = 1;
                this.polygonSelected = [];
                this.select = [];
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
        },

        next() {
            this.axios
            .post("/api/pfs/coordinates/", {'kikandb_id': this.plantId})
            .then((response) => {

                const polygons = response.data.final_polygons.list;
                this.polygonMap.drawPolygonOnMap(polygons, this.polygonMap.featureStyleFunction);
                this.step = 2;
                this.status = response.data.status;
                this.polygonSelected = [];
                this.select = [];
            })
            .catch(() => {
                store.showErrorDialog("発電所の範囲はまだ確定しません。確定してください。");
            });
        },

        deleteSelectedPolygon() {
            const confirmDialog = {
            title: "範囲解除",
            content: '発電所のポリゴンを解除します。よろしいですか。',
            onAgree: () => {
                this.overlay = true;
                this.axios
                    .delete("/api/pfs/"+ this.plantId)
                    .then((response) => {
                        const polygons = response.data.raw_polygons;
                        this.setRawPolygon(polygons);
                        this.status = "NEW";
                        this.index = 0;
                        this.select = [];
                        this.polygonSelected = [];
                        this.step = 1;
                        this.userInfo.flight_status = false;
                    })
                    .catch(() => {
                        store.showErrorDialog("エラーが発生しました。再度試してください。");
                    });
            },
            onDisagree: null,
            };
            store.showConfirmDialog(confirmDialog);
        },
        displaySignBoard(){
            this.showKanbanDialog = true;
        },

        download() {
            this.axios
            .request({
                method: 'post',
                url: '/api/pfs/download/',
                data: {
                    kikandb_id: this.plantId
                },
                responseType: "blob"
            })
            .then((response) => {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', this.kanbanInfo.ministryId+'.zip');
                document.body.appendChild(fileLink);
                fileLink.click();
            })
            .catch(() => {
                store.showErrorDialog("エラーが発生しました。");
            });
        },

        storeFlight() {
            const confirmDialog = {
            title: "撮影完了",
            content: '発電所撮影完了します。よろしいですか。',
            onAgree: () => {
                this.overlay = true;
                this.axios
                    .post("/api/pfs/flight/", {'kikandb_id': this.plantId})
                    .then((response) => {
                        if(response.data.status == true){
                            this.snackbar = true;
                            this.message = "撮影完了！";
                            this.userInfo["flight_status"] = response.data.polygon.flight_status;
                            this.userInfo["flight_completed_at"] = response.data.polygon.flight_completed_at;
                            this.userInfo["flight_completed_user"] = response.data.polygon.flight_completed_user;
                        }
                    })
                    .catch(() => {
                        store.showErrorDialog("エラーが発生しました。再度試してください。");
                    });
            },
            onDisagree: null,
            };
            store.showConfirmDialog(confirmDialog);
        },

        formatText(text) {
            return text.split("@")[0];
        },

        resetLayers() {
            this.layers = [
                {
                    didZone: {
                        transparency: 100,
                        visible: true,
                        text: "人口集中地区",
                        value: 'DIDZone',
                    },
                    noFlightZone: {
                        transparency: 100,
                        visible: true,
                        text: "高度制限地区",
                        value: 'noFlightZone',
                    },
                    visible: true,
                    text: "フライト禁止地区",
                    value: "flightBanArea",
                },
            ];
        },
        onChangeVisible(event, layer) {
            switch (layer.value){
                case 'DIDZone': 
                case 'noFlightZone': {
                    let mapLayer = this.getLayerById(layer.value, this.mapview);
                    if (mapLayer){
                        mapLayer.setVisible(layer.visible);
                    }
                    const naviLayer = this.getNaviLayerByValue('flightBanArea', this.layers);
                    naviLayer.visible = naviLayer.noFlightZone.visible || naviLayer.didZone.visible;
                    mapLayer = this.getLayerById('flightBanArea', this.mapview);
                    if (mapLayer){
                        mapLayer.setVisible(naviLayer.visible);
                    }
                    break;
                }
                case 'flightBanArea': {
                    layer.didZone.visible = layer.visible;
                    layer.noFlightZone.visible = layer.visible;
                    this.getLayerById(layer.value, this.mapview).setVisible(layer.visible);
                    this.getLayerById(layer.noFlightZone.value, this.mapview).setVisible(layer.visible);
                    this.getLayerById(layer.didZone.value, this.mapview).setVisible(layer.visible);
                    break;
                }
                default: {
                this.getLayerById(layer.value, this.map).setVisible(layer.visible);
                }
            }

            event.cancelBubble = true;
        },
        getLayerById(id, fromLayer){
            const layers = fromLayer.getLayers().getArray();
            for (const layer of layers) {
                if (layer.get("id") == id){
                return layer;
                }
                else{
                if (layer instanceof LayerGroup){
                    const a = this.getLayerById(id, layer);
                    if (a) return a;
                }
                }
            }
            return null;
        },
        getNaviLayerByValue(value, layers){
            for (const layer of layers){
                if (layer.value == value){
                return layer;
                }
            }
            return null;
        },

    },
    mounted() {
        this.init();
    }
}
</script>
<style scoped>
.full-size {
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 64px;
    /* padding: 0 5px !important; */
}
#map {
  width: auto;
  height: 100%;
  padding: 0px;
}
#mapPolygon {
    width: 100%;
    height: 100%;
}
#left-panel {
  position: absolute;
  /* top: 10px; */
  left: 12px;
  z-index: 1;
  border-radius: 4px;
  color: white;
}
.btn {
    width: 100%;
}
.v-application .grey {
    background-color: #fff !important;
}
.v-application .grey.lighten-1 {
    background-color: #fff !important;
    /* border-color: #fff !important; */
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
.v-application .mb-12 {
    margin-bottom: 0px !important;
}
.v-stepper--vertical {
    padding-bottom: 0px !important;
}
.v-application--is-ltr .v-stepper--vertical .v-stepper__content {
    margin: 0px !important;
}
.v-stepper--vertical .v-stepper__content {
    padding: 0px 8px;
    width: auto;
}
.v-stepper--vertical .v-stepper__step {
    padding: 16px;
}
.text {
    margin-top: 10px;
    /* display: none; */
}
.v-application p {
    margin-bottom: 0px;
}

.ministry {
    color: black ;
    padding-left: 16px ;
    padding-top: 5px ;
}
>>>.ol-zoom {
    top: .5em;
    right: .5em;
    left: unset;
    bottom: unset;
}

#layer {
  border-left: 1px solid #ccc;
  width: auto;
  height: 100%;
}
#left-panel{
  max-height: calc(100vh - 48px);
  overflow-y: auto;
}
</style>
